var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.dialog, "max-width": "550", persistent: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.confirm.apply(null, arguments)
                },
              },
            },
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(
                    _vm._s(
                      _vm.payslips.length == 1
                        ? "Publicar recibo"
                        : "Publicar recibos"
                    )
                  ),
                ]),
              ]),
              _c(
                "v-card-text",
                [
                  _vm.payslips.length == 1
                    ? _c("p", { staticClass: "mb-2" }, [
                        _vm._v(" Se publica el recibo "),
                        _c("b", [
                          _vm._v(_vm._s(_vm.periodLabel(_vm.payslips[0]))),
                        ]),
                        _vm._v(" de "),
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.legajoLabel(_vm.payslips[0].legajo))
                          ),
                        ]),
                        _vm._v(". "),
                      ])
                    : _c("p", { staticClass: "mb-2" }, [
                        _vm._v(" Se publican "),
                        _c("b", [_vm._v(_vm._s(_vm.publishable.length))]),
                        _vm._v(" recibos. "),
                      ]),
                  _vm.publishable.length < _vm.payslips.length
                    ? _c(
                        "p",
                        { staticClass: "mb-2 orange--text text--darken-3" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.payslips.length - _vm.publishable.length
                              ) +
                              " de los seleccionados no se pueden publicar (no están en borrador o no tienen legajo) y se omiten. "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("p", { staticClass: "mb-4" }, [
                    _vm._v(
                      "Cada empleado recibe un aviso por email y en la aplicación."
                    ),
                  ]),
                  _c(
                    "v-radio-group",
                    {
                      staticClass: "mt-0",
                      model: {
                        value: _vm.mode,
                        callback: function ($$v) {
                          _vm.mode = $$v
                        },
                        expression: "mode",
                      },
                    },
                    [
                      _c("v-radio", {
                        attrs: { label: "Publicar ahora", value: "now" },
                      }),
                      _c("v-radio", {
                        attrs: {
                          label: "Programar para una fecha",
                          value: "scheduled",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.mode == "scheduled"
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "close-on-content-click": false,
                                  transition: "scale-transition",
                                  "offset-y": "",
                                  "min-width": "290px",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required",
                                                      expression: "'required'",
                                                    },
                                                  ],
                                                  attrs: {
                                                    value: _vm.formatDate(
                                                      _vm.date
                                                    ),
                                                    label: "Fecha*",
                                                    name: "date",
                                                    "data-vv-as": "fecha",
                                                    "prepend-icon":
                                                      "mdi-calendar",
                                                    readonly: "",
                                                  },
                                                },
                                                "v-text-field",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3221202247
                                ),
                                model: {
                                  value: _vm.menu_date,
                                  callback: function ($$v) {
                                    _vm.menu_date = $$v
                                  },
                                  expression: "menu_date",
                                },
                              },
                              [
                                _c("v-date-picker", {
                                  attrs: { locale: "es", min: _vm.today },
                                  on: {
                                    input: function ($event) {
                                      _vm.menu_date = false
                                    },
                                  },
                                  model: {
                                    value: _vm.date,
                                    callback: function ($$v) {
                                      _vm.date = $$v
                                    },
                                    expression: "date",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("span", { staticClass: "red--text" }, [
                              _vm._v(_vm._s(_vm.errors.first("date"))),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            _c("v-text-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                type: "time",
                                label: "Hora*",
                                name: "time",
                                "data-vv-as": "hora",
                              },
                              model: {
                                value: _vm.time,
                                callback: function ($$v) {
                                  _vm.time = $$v
                                },
                                expression: "time",
                              },
                            }),
                            _c("span", { staticClass: "red--text" }, [
                              _vm._v(_vm._s(_vm.errors.first("time"))),
                            ]),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        text: "",
                        disabled: _vm.loading,
                      },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        text: "",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: _vm.publishable.length == 0,
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.mode == "now" ? "Publicar" : "Programar") +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }